import React from 'react';
import { Table, Button, Row, Col } from 'reactstrap';

const ExceptionsTable = ({ columns, exceptions, removeHoliday }) => {
  const formatDays = (exception) => {
    const days = [];
    if (exception.monday) days.push('Seg');
    if (exception.tuesday) days.push('Ter');
    if (exception.wednesday) days.push('Qua');
    if (exception.thursday) days.push('Qui');
    if (exception.friday) days.push('Sex');
    if (exception.saturday) days.push('Sáb');
    if (exception.sunday) days.push('Dom');
    return days.join(', ');
  };
  return (
    <Row className="mb-3">
      <Col className="col-md-12">
        <Table>
          <thead>
            <tr>
              {columns.map((column, index) => (
                <th key={index}>{column}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {exceptions.map((exception, index) => {
              return (
                <tr key={index}>
                  {exception.pause?.name ? (
                    <td>{exception.pause.name}</td>
                  ) : (
                    <td>{exception.pauseName}</td>
                  )}
                  <td>
                    {exception.intervalReference === 'ENTRY'
                      ? 'Após a entrada'
                      : 'Antes da saída'}
                  </td>
                  <td>{formatDays(exception)}</td>
                  <td>{exception.triggerInterval}</td>
                  <td>{exception.duration}</td>
                  <td>{exception.toleranceTime}</td>
                  <td>
                    <Button
                      size="sm"
                      color="danger"
                      onClick={(event) => {
                        removeHoliday(event, index);
                      }}
                    >
                      <li className="fas fa-trash"></li>
                    </Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </Col>
    </Row>
  );
};

export default ExceptionsTable;
